import { useState } from 'react'
import { useTaskFiles, useDeleteTaskFile } from '../../hooks'
import type { TaskFile } from '../../types'
import { FileCard } from './FileCard'
import { FileDeleteDialog } from './FileDeleteDialog'

interface Props {
  taskId: number
}

/** Lista plików zadania (sortowana DESC po uploadedAt). Brak plików -> placeholder. */
export function FilesList({ taskId }: Props) {
  const { data: files = [], isLoading } = useTaskFiles(taskId)
  const deleteFile = useDeleteTaskFile(taskId)
  const [toDelete, setToDelete] = useState<TaskFile | null>(null)

  if (isLoading) return <p className="text-xs text-slate-400">Ładowanie…</p>
  if (files.length === 0) {
    return <p className="text-xs italic text-slate-400">Brak plików.</p>
  }

  return (
    <>
      <div className="flex flex-col gap-2">
        {files.map((f) => (
          <FileCard key={f.id} file={f} taskId={taskId} onDelete={setToDelete} />
        ))}
      </div>
      {toDelete && (
        <FileDeleteDialog
          file={toDelete}
          onConfirm={() =>
            deleteFile.mutate(toDelete.id, { onSuccess: () => setToDelete(null) })
          }
          onCancel={() => setToDelete(null)}
        />
      )}
    </>
  )
}
